var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4578_11494)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4578_11494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H64V64H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4578_11494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.286 20.875H61.4996L53.9996 47.125H20.7496C18.6786 47.125 16.9996 48.804 16.9996 50.875C16.9996 52.9461 18.6786 54.625 20.7496 54.625H50.7496",
    stroke: "#A1A4B2",
    strokeWidth: 3.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 17.125C1.875 15.0539 3.554 13.375 5.625 13.375H9.5C11.571 13.375 13.25 15.0539 13.25 17.125",
    stroke: "#A1A4B2",
    strokeWidth: 3.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7507 47.125L13.1421 16.2254",
    stroke: "#A1A4B2",
    strokeWidth: 3.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 58.375C32 60.4461 30.321 62.125 28.25 62.125C26.179 62.125 24.5 60.4461 24.5 58.375C24.5 56.304 26.179 54.625 28.25 54.625C30.321 54.625 32 56.304 32 58.375Z",
    stroke: "#A1A4B2",
    strokeWidth: 3.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 58.375C54.5 60.4461 52.821 62.125 50.75 62.125C48.679 62.125 47 60.4461 47 58.375C47 56.304 48.679 54.625 50.75 54.625C52.821 54.625 54.5 56.304 54.5 58.375Z",
    stroke: "#A1A4B2",
    strokeWidth: 3.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.625 5.62497V1.87497",
    stroke: "#A1A4B2",
    strokeWidth: 3.75,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.017 10.0184L24.3654 7.36675",
    stroke: "#A1A4B2",
    strokeWidth: 3.75,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2329 10.0184L50.8845 7.36675",
    stroke: "#A1A4B2",
    strokeWidth: 3.75,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4578_11494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart1);
export default __webpack_public_path__ + "static/media/empty-cart 1.d1f93747558d1142ac94b96a95f36f3f.svg";
export { ForwardRef as ReactComponent };